/**
 * Minimal column descriptor shared by the column-selector popover and the
 * grid view-state layer: enough to identify a column, label it, and carry
 * its default visibility. Grids build these from their full column defs
 * (see e.g. `toPickerColumns` in SamplesTab).
 */
export interface PickerColumn {
  /** Explicit stable id; wins over `field` when both are present. */
  colId?: string;
  field?: string;
  headerName?: string;
  /** Default visibility when no explicit visibility map is supplied. */
  hide?: boolean;
}

/**
 * Resolves the stable column id for a picker column. Prefers an explicit
 * `colId`, falls back to `field`, then `headerName`, then `"?"`. This is
 * what should be used both as a key into a visibility/state map AND as the
 * grid column id so the two stay in sync.
 *
 * @param col - Picker column descriptor
 * @returns The field key for the column
 */
export const getFieldKey = (col: PickerColumn): string => {
  return col.colId || col.field || col.headerName || "?";
};
